import { API_BASE_URL } from './config';
import { apiFetch, isNetworkError } from './helpers';

interface PipelineStatusResponse {
    configured: boolean;
    status?: string | null;
    result?: string | null;
    buildNumber?: string | null;
}

type PipelineState = 'running' | 'succeeded' | 'failed' | 'unknown';

function stateFor(data: PipelineStatusResponse): PipelineState {
    if (data.status === 'inProgress' || data.status === 'notStarted' || data.status === 'postponed') return 'running';
    if (data.result === 'succeeded') return 'succeeded';
    if (data.result === 'failed' || data.result === 'canceled' || data.result === 'partiallySucceeded') return 'failed';
    return 'unknown';
}

const LABELS: Record<PipelineState, string> = {
    running: 'Pipeline running',
    succeeded: 'Pipelines',
    failed: 'Pipeline failed',
    unknown: 'Pipelines',
};

export async function fetchPipelineStatus(): Promise<void> {
    const link = document.getElementById('dev-pipelines-link');
    const dot = document.getElementById('pipeline-dot');
    const label = document.getElementById('pipeline-label');
    if (!link || !dot || !label) return;

    try {
        const response = await apiFetch(`${API_BASE_URL}/pipeline`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data: PipelineStatusResponse = await response.json();
        if (!data.configured) {
            dot.className = 'pipeline-dot';
            return;
        }

        const state = stateFor(data);
        dot.className = `pipeline-dot pipeline-dot-${state}`;
        label.textContent = LABELS[state];
        link.title = data.buildNumber
            ? `Azure DevOps Pipelines — ${data.buildNumber}: ${data.status}${data.result ? ` (${data.result})` : ''}`
            : 'Azure DevOps Pipelines';
    } catch (error) {
        if (!isNetworkError(error)) console.error('Failed to fetch pipeline status:', error);
        dot.className = 'pipeline-dot';
    }
}
